import Image from "next/image";
import IMAGES from "../../../../../images/importImages";
import { conditions } from "../../../../../helpers";
import { ConditionName, ISpeedIconProps } from "../../../../../interfaces";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux'

const SpeedIcon = (props: ISpeedIconProps) => {

    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i 
                    className={`fa-solid fa-gauge pl-cursor-pointer pl-text-white ${conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[22px]"}`}
                    {...props}
                />
            ) : (
                <Image
                    alt="speed-icon"
                    src={IMAGES.speed}
                    className="pl-flex pl-items-center pl-cursor-pointer"
                    width={conditions(ConditionName.isMiniPlayer) ? 13 : 22}
                    height={conditions(ConditionName.isMiniPlayer) ? 14 : 22}
                    {...props}
                />
            )}
        </>
    )
}

export default SpeedIcon;